<template>
  <div class="content">
    <div class="header">
      <Header></Header>
    </div>
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <div class="all" style="background-color: white">
          <el-row>
            <el-col :span="24">
              <el-steps :active="active1" align-center style="background:#DCDFE6;height: 70px;padding-top: 40px;margin-top: 25px">
                <el-step title="信息提交"></el-step>
                <el-step title="完成缴费"></el-step>
                <el-step title="报名完成"></el-step>
              </el-steps>
            </el-col>
          </el-row>
          <div v-if="active1===1">
            <!--          订单信息-->
            <el-row type="flex" justify="center">
              <el-col :span="22">
                <div class="title" style="margin-top: 35px">订单信息</div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="left" style="margin-top: 50px">
              <el-col :offset="1" :span="22">
                <template>
                  <el-table
                      border
                      :data="tableData"
                      style="width: 100%;">
                    <el-table-column
                        prop="policyName"
                        label="类型"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="endTime"
                        label="截止时间"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="fee"
                        label="单价">
                    </el-table-column>
                    <el-table-column
                        label="数量">
                      <template>
                        <el-input-number  v-model="totalNum"  :disabled="true" ></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="合计(元)">
                      <template>
                        <span>{{this.amount}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-col>
            </el-row>

            <!--          发票信息填写-->
            <el-row v-if="type==='0'?0:1" type="flex" justify="center">
              <el-col :span="22">
                <div class="title" style="margin-top: 35px">发票信息填写</div>
              </el-col>
            </el-row>
            <el-row v-if="type==='0'?0:1" type="flex" justify="left" style="margin-top: 25px">
              <el-col :offset="1" :span="5">
                <span style="color: red;font-size: 16px">提示：信息填写后请注意保存!</span>
              </el-col>
            </el-row>
            <el-row type="flex" justify="left" style="margin-top: 20px">
              <el-col :offset="1" :span="6">
                <template>
                  <el-radio-group v-model="type" @change="clear">
                    <el-radio v-if="bill.ebill" label="1">电子发票</el-radio>
                    <el-radio v-if="bill.sbill" label="2">专用发票</el-radio>
                  </el-radio-group>
                </template>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="22" v-if="this.type === '1'">
                <div style="margin-top: 35px">
                  <el-form ref="form1Ref" :model="form1" :rules="formRules1">
                    <el-row type="flex" justify="left" style="margin-top: 15px">
                      <el-col :span="6">
                        <template>
                          <el-form-item v-if="PersonList.length>1" label="是否开在一张发票上 " prop="isMerge">
                            <el-select v-model="form1.isMerge" placeholder="请选择">
                              <el-option
                                  v-for="item in options3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="发票单位" prop="unitName">
                          <el-input v-model="form1.unitName"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :offset="2" :span="6">
                        <el-form-item label="纳税人识别号" prop="identityNum">
                          <el-input v-model="form1.identityNum"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :offset="2" :span="6">
                        <el-form-item label="发票接收邮箱地址" prop="email">
                          <el-input v-model="form1.email"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center" style="margin-top: 35px;">
                      <el-col :span="2">
                        <el-form-item>
                          <el-button type="primary" v-preventReClick @click="upData">保存</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
              <el-col :span="22" v-if="this.type === '2'">
                <el-row type="flex" justify="left" style="margin-top: 25px">
                  <el-col :span="6">
                    <span style="font-size: 14px;color: red">注意：专用发票领取方式为现场领取！</span>
                  </el-col>
                </el-row>
                <div class="Form1"  style="margin-top: 20px">
                  <el-form :model="form2" ref="form2Ref" :rules="formRules2">
                    <el-row type="flex" justify="left" style="margin-top: 15px">
                      <el-col :span="6">
                        <template>
                          <el-form-item v-if="PersonList.length>1" label="是否开在一张发票上 " prop="isMerge">
                            <el-select v-model="form2.isMerge" placeholder="请选择">
                              <el-option
                                  v-for="item in options3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="发票单位" prop="unitName">
                          <el-input v-model="form2.unitName"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :offset="2" :span="6">
                        <el-form-item label="纳税人识别号" prop="identityNum">
                          <el-input v-model="form2.identityNum"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :offset="2" :span="6">
                        <el-form-item label="地址" prop="address">
                          <el-input v-model="form2.address"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="电话" prop="phonenumber" key="phonenumber">
                          <el-input v-model="form2.phonenumber"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :offset="2" :span="6">
                        <el-form-item label="开户行" prop="bank">
                          <el-input v-model="form2.bank"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :offset="2" :span="6">
                        <el-form-item label="开户行账号" prop="account">
                          <el-input v-model="form2.account"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center" style="margin-top: 35px;">
                      <el-col :span="2">
                        <el-form-item>
                          <el-button type="primary" v-preventReClick @click="upData">保存</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
            </el-row>

            <!--          参会人员信息填写-->
            <el-row type="flex" justify="center">
              <el-col :span="22">
                <div class="title" style="margin-top: 35px">参会人员信息填写</div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="22">
                <div style="margin-top: 35px">
                  <el-table :data="PersonList" border>
                    <el-table-column fixed="left" type="index" label="#"></el-table-column>
                    <el-table-column width="200" label="手机号" prop="phoneNumber">
                      <template slot-scope="scope">
                        <el-input disabled v-model="scope.row.phonenumber" />
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="姓名" prop="nickName">
                      <template slot-scope="scope">
                        <el-input disabled v-model="scope.row.nickName" />
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="性别" prop="sex">
                      <template slot-scope="scope">
                        <el-select disabled v-model="scope.row.sex" placeholder="请选择">
                          <el-option
                              v-for="item in options1"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="邮箱" prop="email">
                      <template slot-scope="scope">
                        <el-input disabled v-model="scope.row.email" />
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="单位" prop="unitName">
                      <template slot-scope="scope">
                        <el-input disabled v-model="scope.row.unitName" />
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="职务" prop="duty">
                      <template slot-scope="scope">
                        <el-input disabled v-model="scope.row.duty" />
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="职称" prop="titles">
                      <template slot-scope="scope">
                        <el-input disabled v-model="scope.row.titles" />
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="拟参加分会场" prop="subConfId">
                      <template slot-scope="scope">
                        <el-select disabled v-model="scope.row.subConfId" placeholder="请选择">
                          <el-option
                              v-for="item in options2"
                              :key="item.subConfId"
                              :label="item.subConfName"
                              :value="item.subConfId">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="120"  label="操作">
                      <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="openPersonForm(scope.row,scope.$index)"></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
            <!--          下一步-->
            <el-row type="flex" justify="center">
              <el-col :offset="1" :span="3" style="margin-bottom: 50px;margin-right: 10px;margin-top: 35px">
                <el-button v-if="finish" v-preventReClick  size="middle" type="primary" @click="toNext()">下一步</el-button>
              </el-col>
            </el-row>
            <!--          修改人员信息窗口-->
            <el-dialog @close="closed"  title="编辑参会人员信息" :visible.sync="dialogFormVisible">
              <el-form  style="padding-left: 80px;" :model="changePersonForm" :rules="changePersonFormRules"  ref="addEduFormRef">
                <el-form-item label="手机号" prop="phonenumber">
                  <el-row>
                    <el-col :span="20">
                      <el-input  v-model="changePersonForm.phonenumber" autocomplete="off"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="姓名" prop="nickName" >
                  <el-row>
                    <el-col :span="20">
                      <el-input  v-model="changePersonForm.nickName" autocomplete="off"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="邮箱" prop="email" >
                  <el-row>
                    <el-col :span="20">
                      <el-input  v-model="changePersonForm.email" autocomplete="off"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="性别" prop="sex" >
                  <template>
                    <el-select v-model="changePersonForm.sex" placeholder="请选择">
                      <el-option
                          v-for="item in options1"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-form-item>
                <el-form-item label="单位" prop="unitName" >
                  <el-row>
                    <el-col :span="20">
                      <el-input  v-model="changePersonForm.unitName" autocomplete="off"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="职务" prop="duty" >
                  <el-row>
                    <el-col :span="20">
                      <el-input  v-model="changePersonForm.duty" autocomplete="off"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="职称" prop="titles">
                  <el-row>
                    <el-col :span="20">
                      <el-input  v-model="changePersonForm.titles" autocomplete="off"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="拟参加分会场" prop="subConfId" >
                  <el-row>
                    <el-col :span="20">
                      <el-select v-model="changePersonForm.subConfId" placeholder="请选择">
                        <el-option
                            v-for="item in options2"
                            :key="item.subConfId"
                            :label="item.subConfName"
                            :value="item.subConfId">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="closed" v-preventReClick>取 消</el-button>
                <el-button type="primary" v-preventReClick @click="change">保存</el-button>
              </div>
            </el-dialog>
          </div>

          <div v-if="active1===2">
            <el-row type="flex" justify="center">
              <el-col :span="22"><div class="title" style="margin-top: 35px">缴费方式选择</div></el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 50px">
              <el-col :span="22">
                <el-tabs style="width: 90%;margin: 15px auto 0;" v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane name="wxpay" label="微信支付">
                    <div v-if="payWeixin === 1" style="margin-bottom: 50px">
                      <el-row type="flex" justify="center">
                        <el-col style="width: 150px;text-align: center">
                          <h3 style="color: red">￥{{amount}}</h3>
                        </el-col>
                      </el-row>
                      <el-row type="flex" justify="center">
                        <el-col style="width: 250px;text-align: center">
                          <span>请使用微信扫码支付</span>
                        </el-col>
                      </el-row>
                      <el-row type="flex" justify="center">
                        <el-col style="width: 340px;text-align: center">
                          <vue-qr style="margin-top: 20px;margin-left: 10px" :logoSrc="imgUrl"  :text="img" :size="200"></vue-qr>
                        </el-col>
                      </el-row>
                      <el-row type="flex" justify="center">
                        <el-col style="width: 340px;text-align: center;margin-bottom: 50px">
                          <span style="font-size: 12px">订单号：{{orderNo}}</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="payWeixin === 2">
                      <el-result icon="success" title="支付成功">
                        <template slot="extra">
                          <span style="font-size: 14px">{{sendmsg}}后跳转报名完成页面</span>
                        </template>
                      </el-result>
                    </div>
                    <div v-if="payWeixin === 3">
                      <el-result icon="error" title="支付失败" subTitle="请根据提示进行操作">
                        <template slot="extra">
                          <el-button type="primary" size="medium" v-preventReClick @click="back">返回类型选择</el-button>
                        </template>
                      </el-result>
                    </div>
                    <div v-if="payWeixin === 4">
                      <el-result icon="warning" title="订单已超时" subTitle="请根据提示进行操作">
                        <template slot="extra">
                          <el-button type="primary" size="medium" v-preventReClick  @click="back">返回类型选择</el-button>
                        </template>
                      </el-result>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane name="offline" label="银行汇款">
                    <el-row type="flex" justify="center">
                      <el-col style="width: 150px;text-align: center">
                        <h3 style="color: red">￥{{amount}}</h3>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                      <el-col style="width: 350px;text-align: center">
                        <span style="font-size: 12px">订单号：{{orderNo}}</span>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                      <el-col style="width: 150px;text-align: center">
                        <el-button style="margin: 50px 0 50px 15px" type="primary" v-preventReClick @click="payOffline">线下支付</el-button>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane name="sitepay" label="现场支付">
                    <el-row type="flex" justify="center">
                      <el-col style="width: 280px;text-align: center;">
                        <span style="color: red">注意：现场支付没有优惠！</span>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                      <el-col style="width: 150px;text-align: center">
                        <h3 style="color: red">￥{{amount}}</h3>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                      <el-col style="width: 350px;text-align: center">
                        <span style="font-size: 12px">订单号：{{orderNo}}</span>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                      <el-col style="width: 150px;text-align: center">
                        <el-button style="margin: 50px 0 50px 15px" type="primary" v-preventReClick @click="paySitePay">现场支付</el-button>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>

          <div v-if="active1===3">
            <el-result v-if="this.activeName==='wxpay'" icon="success" title="报名成功">
              <template slot="extra">
                <h3 style="color: red">￥{{amount}}</h3>
                <span style="font-size: 12px">订单号：{{orderNo}}</span>
                <p style="font-size: 14px">可前往个人中心查看订单信息</p>
              </template>
            </el-result>
            <el-result v-if="this.activeName==='offline'" icon="success" title="报名成功,请完成对公转账">
              <template slot="extra">
                <h3 style="color: red">￥{{amount}}</h3>
                <span style="font-size: 12px">订单号：{{orderNo}}</span>
                <p style="font-size: 20px">对公转账：</p>
                <h5>开户名称：{{accountName}}</h5>
                <h5>开户银行：{{bank}}</h5>
                <h5>银行账户：{{accountNum}}</h5>
                <span  style="color: red;font-size: 18px">注意事项：</span>
                <span v-html="remark" style="color: red;font-size: 16px"></span>
                <p style="font-size: 14px">可前往个人中心查看订单信息</p>
              </template>
            </el-result>
            <el-result v-if="this.activeName==='sitepay'" icon="success" title="报名完成">
              <template slot="extra">
                <h3 style="color: red">￥{{amount}}</h3>
                <span style="font-size: 12px">订单号：{{orderNo}}</span>
                <p style="font-size: 14px">可前往个人中心查看订单信息</p>
              </template>
            </el-result>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vueQr from "vue-qr";
export default {
name: "signUpForm",
  components: {
    vueQr
  },
  data(){
    var chekEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
      if (value === '') {
        callback(new Error('请输入邮箱'));
      } else {
        if (regEmail.test(value)) {
          // 合法的邮箱
          callback()
        } else {
          callback(new Error('请输入合法的邮箱'))
        }

      }
    }
    var checkPhone= (rule, value, callback) =>{
      const regPhone = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (!value) {
        callback(new Error('请输入联系电话'));
      }else {
        if (regPhone.test(value)) {
          callback()
        } else {
          callback(new Error('请输入合法的手机号'))
        }
      }
    };
    return{
      //active2
      payWeixin:1,
      activeName:'wxpay',
      imgUrl:require("../assets/logo1.jpg"),
      img: '',
      code:'',
      money:'',
      sendmsg:'',
      //支付状态刷新定时器
      time:'',

      //线下支付信息
      accountName:'',
      accountNum:'',
      bank:'',
      remark:'',

      //所有信息是否填写完成
      finish:false,

      policyId:1,
      confId:'',
      orderNo:'',
      policyName:'',
      amount:'',
      totalNum:'',

      active1:this.$store.state.active,

      PersonList: [],

      options1:[
        {
          value: '0',
          label: '男'
        }, {
          value: '1',
          label: '女'
        },
      ],
      options2:[],

      options3:[
         {
          value: 1,
          label: '是',
        },
        {
          value: 0,
          label: '否'
        },
      ],

      //订单信息
      tableData:[],
      //发票类型
      type: '0',


      //发票是否显示
      //0隐藏1显示
      // 电子发票
      // 专用发票
      bill:{},

      //两种发票表单
      form1:{
        unitName:'',
        identityNum:'',
        email:'',
        type:'0',
        orderNo:'',
        isMerge:1
      },
      form2:{
        unitName:'',
        identityNum:'',
        address:'',
        bank:'',
        account:'',
        phonenumber:'',
        type:1,
        orderNo:'',
        isMerge:1
      },

      changePersonForm:{
        phonenumber:'',
        nickName:'',
        email:'',
        sex:'',
        unitName:'',
        duty:'',
        titles:'',
        subConfId:''
      },
      dialogFormVisible:false,

      changePersonFormRules: {
        phonenumber: [
          { required:true,validator: checkPhone,trigger: 'blur'}
        ],
        nickName: [
          { required: true, message: '请填写参会人员姓名', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请填写参会人员邮箱', trigger: 'blur' },
          { validator: chekEmail,trigger: 'blur'}
        ],
        sex: [
          { required: true, message: '请选择参会人员性别', trigger: 'blur' },
        ],
        unitName: [
          { required: true, message: '请填写参会人员所在单位', trigger: 'blur' },
        ],
        duty: [
          { required: true, message: '请填写参会人员担任职务', trigger: 'blur' },
        ],
        titles: [
          { required: true, message: '请填写参会人员职称', trigger: 'blur' },
        ],
        subConfId: [
          { required: true, message: '请选择您想要参加的分会场', trigger: 'blur' },
        ]
      },
      formRules1: {
        unitName: [
          { required: true, message: '请填写发票单位', trigger: 'blur' },
        ],
        identityNum: [
          { required: true, message: '请填写纳税人识别号', trigger: 'blur' },
        ],
        email: [
          { required: true,validator: chekEmail,trigger: 'blur'}
        ],
        isMerge: [
          { required: true, message: '是否开在一张发票上 ',trigger: 'blur'},
        ],
      },
      formRules2: {
        unitName: [
          { required: true, message: '请填写发票单位', trigger: 'blur' },
        ],
        identityNum: [
          { required: true, message: '请填写纳税人识别号', trigger: 'blur' },
        ],
        bank: [
          { required: true, message: '请填写开户行', trigger: 'blur' },
        ],
        account: [
          { required: true, message: '请填写开户行账号', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请填写地址', trigger: 'blur' },
        ],
        phonenumber: [
          { required: true, validator: checkPhone,trigger: 'blur'},
        ],
        isMerge: [
          { required: true, message: '是否开在一张发票上 ',trigger: 'blur'},
        ],
      },

    }
  },
  methods:{

    //获取发票信息
    async getconfBill(){
      const { data: res } = await this.$http.get('api/conference/confBill/'+this.orderNo)
      console.log(res);
      if(res.data){
        if(res.data.type === 0){
          this.type ='1'
          this.form1.email = res.data.email
          this.form1.identityNum = res.data.identityNum
          this.form1.unitName = res.data.unitName
          this.form1.isMerge = res.data.isMerge
          this.form2.identityNum = ''
          this.form2.unitName = ''
          this.form2.address = ''
          this.form2.bank = ''
          this.form2.phonenumber = ''
          this.form2.account = ''
        }
        if(res.data.type === 1){
          this.type = '2'
          this.form1.email = ''
          this.form1.identityNum = ''
          this.form1.unitName = ''
          this.form2.identityNum = res.data.identityNum
          this.form2.unitName = res.data.unitName
          this.form2.address = res.data.address
          this.form2.bank = res.data.bank
          this.form2.phonenumber = res.data.phonenumber
          this.form2.account = res.data.account
          this.form2.isMerge = res.data.isMerge

        }
        this.finish = res.finish
      }
    },
    //获取是否隐藏发票
    async getbillConfig(){
      const { data: res } = await this.$http.get('api/conference/confBill/billConfig/'+this.confId)
      // console.log(res);
      this.bill = res
      if(this.bill.ebill === 1 && this.bill.sbill === 1){
        return this.type = '1'
      }else if(this.bill.ebill === 0 && this.bill.sbill === 1){
        return  this.type = '2'
      }else if(this.bill.ebill === 1 && this.bill.sbill === 0){
        return this.type = '1'
      }else if(this.bill.ebill === 0 && this.bill.sbill === 0){
        return  this.type = '0'
      }
    },
    //切换发票类型清除表单内容
    clear(){
      if(this.type === '1'){
        this.$refs.form1Ref.resetFields();
      }else if(this.type === '2'){
        this.$refs.form2Ref.resetFields();
      }
    },

    //获取分会场
    async getSubList(){
      const { data: res } = await this.$http.get('api/conference/ConfSubDetailed/allList/'+this.confId)
      // console.log(res);
      this.options2 = res.data
    },

    //active2
    //切换支付方式
    handleClick(tab){
      if(tab.name ==='wxpay'){
        clearInterval(this.time)
        this.payWx()
        this.activeName='wxpay'
      }else if(tab.name === 'offline'){
        this.activeName='offline'
        clearInterval(this.time)
      }else if(tab.name === 'sitepay'){
        this.activeName='sitepay'
        clearInterval(this.time)
      }
    },
    //提交微信支付订单信息
    async payWx(){
      var that = this;
      const { data: res } = await this.$http.post('api/conference/pay/confOrder/nativePay',{orderNo:this.orderNo,payTool:'wxpay'})
      // console.log(res);
      if(res.code === 200){
        this.img = res.result.codeUrl
        this.payWeixin = 1
        this.time = setInterval(function (){
          that.getPayState()
        },1000)
      }else{
        return this.$message.error(res.msg)
      }
    },
    //提交银行汇款订单信息
    async payOffline(){
      const { data: res } = await this.$http.post('api/conference/pay/confOrder/nativePay',{orderNo:this.orderNo,payTool:'remitpay'})
      // console.log(res);
      if(res.code === 200){
        this.$store.dispatch('addActive')
        this.getOffline()
      }else{
        return this.$message.error(res.msg)
      }

    },
    //获取线下支付信息
    async getOffline(){
      const { data: res } = await this.$http.get('api/conference/bankConfig/'+this.confId)
      if(res.code === 200){
        // console.log(res);
        this.accountName = res.data.accountName
        this.accountNum = res.data.accountNum
        this.bank = res.data.bank
        this.remark = res.data.remark
      }else{
        return this.$message.error(res.msg)
      }
      // console.log(res);
    },
    //提交现场支付订单信息
    async paySitePay(){
      const { data: res } = await this.$http.post('api/conference/pay/confOrder/nativePay',{orderNo:this.orderNo,payTool:'sitepay'})
      // console.log(res);
      if(res.code === 200){
        this.$store.dispatch('addActive')
      }else{
        return this.$message.error(res.msg)
      }
    },
    //获取支付状态
    async getPayState(){
      const { data: res } = await this.$http.post('api/conference/pay/confOrder/check/'+this.orderNo)
      console.log(res);
      if(res.code === 200){
        this.$message.success('支付成功')
        this.payWeixin = 2
        clearInterval(this.time)
        let timer = 3;
        this.sendmsg = timer + "s";
        this.timeFun = setInterval(() => {
          --timer;
          this.sendmsg = timer + "s";
          if (timer === 0) {
            this.sendmsg = "";
            clearInterval(this.timeFun);
            this.$store.dispatch('addActive')
          }
        }, 1000);
      }else if(res.code === 201){
        this.payWeixin = 1
      }else if(res.code === 202){
        this.$message.warning('订单已超时')
        this.payWeixin = 4
        clearInterval(this.time1)
      }else if(res.code === 203){
        this.$message.error('订单支付失败')
        this.payWeixin = 3
        clearInterval(this.time1)
      }
    },
    //微信支付返回第一步
    back(){
      this.$store.dispatch('subActive')
    },


    // acitve1
    //关闭修改人员信息窗口
    closed(){
      this.getUser()
      this.dialogFormVisible = false
    },
    //打开修改人员信息窗口
    openPersonForm(row,index){
      // console.log(row);
      this.dialogFormVisible = true
      this.changePersonForm = row
      this.$store.dispatch('saveChangePersonFormIndex',index)
    },
    //获取支付信息
    async getPayInformation(id){
      const { data: res } = await this.$http.post('api/conference/confPolicy/allList/'+id)
      if(res.code === 200){
        for(let i=0;i<res.data.length;i++){
          if(res.data[i].policyId == this.policyId){
            this.tableData.push(res.data[i])
          }
        }
      }else{
        return this.$message.error(res.msg)
      }
    },
    //提交人员信息
    change(){
      this.$refs.addEduFormRef.validate(async (valid) => {
        if (valid) {
          this.PersonList[this.$store.state.changePersonFormIndex] = this.changePersonForm
          this.upDataPerson()
          this.dialogFormVisible = false
        }else {
          return false;
        }
      });
    },
    //保存发票信息
    upData(){
      if(this.type==='1'){
        this.$refs.form1Ref.validate(async (valid) => {
          if (valid) {
            const { data: res } = await this.$http.post('api/conference/confBill',this.form1)
            if(res.code === 200){
              // console.log(res);
              this.getconfBill()
              this.$message.success('保存成功')
            }else{
              // console.log(res);
              this.$message.error('保存失败')
            }
          } else {
            return false;
          }
        });
      }
      if(this.type==='2'){
        this.$refs.form2Ref.validate(async (valid) => {
          if (valid) {
            const { data: res } = await this.$http.post('api/conference/confBill',this.form2)
            // console.log(res);
            if(res.code === 200){
              // console.log(res);
              this.getconfBill()
              this.$message.success('Save success')
            }else{
              // console.log(res);
              this.$message.error('Save failed')
            }
          } else {
            return false;
          }
        });
      }
    },

    //保存人员信息
    async upDataPerson(){
      const { data: res } = await this.$http.post('api/conference/confUser/user/batchAddConfUser',
          {confId:this.confId,orderNo:this.orderNo,confUserList:this.PersonList})
      console.log(res);
      if(res.code === 200){
        this.$message.success('Save success')
      }
      this.getUser()
    },
    //获取人员信息
    async getUser(){
      const { data: res } = await this.$http.get('api/conference/confUser/list?orderNo='+this.orderNo)
      // console.log(res);
      // console.log(this.orderNo);
      if(res.code === 200){
        if(res.data.length){
          this.PersonList = res.data
        }
        this.finish = res.finish
      }else {
        this.$message.error(res.msg)
      }
    },
    //预创建人员信息
    makePersonList() {
      for(let i =0 ;i<this.totalNum;i++){
        let obj = {};
        obj.phonenumber = ''
        obj.nickName = ''
        obj.sex = ''
        obj.email = ''
        obj.duty = ''
        obj.subConfId = ''
        obj.unitName = ''
        obj.titles = ''
        this.PersonList.push(obj);
      }
    },
    //下一步
    toNext(){
      this.$store.dispatch('addActive')
      this.payWx()
      this.payWeixin = 1
    }
  },
  created() {
    this.confId = this.$route.query.confId
    this.orderNo = this.$route.query.orderNo
    this.amount = this.$route.query.amount
    this.policyId = this.$route.query.policyId
    this.totalNum = this.$route.query.totalNum
    this.form1.orderNo=this.$route.query.orderNo
    this.form2.orderNo=this.$route.query.orderNo
    if(this.active1 === 2 ){
      this.payWx()
      this.activeName='wxpay'
    }
  },
  mounted() {
    this.makePersonList()
    this.getUser()
    this.getconfBill()
    this.getPayInformation(this.confId)
    this.getSubList()
    this.getbillConfig()
  },
  watch:{
    '$store.state.active': {
      handler(){
        this.active1 = this.$store.state.active
      }
    }
  }
}
</script>

<style scoped lang="less">
.content{
  display: flex;
  flex-direction: column;
}
.page{
  background-color: #f2f2f2;
}
.title{
  /*height: ;*/
  font-size: 18px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 10px;
  color: #1da7fe;
  border-left: solid 6px #1da7fe !important;
  border-right: solid 3px #1da7fe !important;
  background-color: #fbfbfb;
}
#one .el-radio{
  margin-top: 15px;
}
</style>
